<template>
    <div>
        <v-container fluid>
            <v-form  ref="searchContactListForm" @submit="get()" onSubmit="return false">
                <v-card flat>
                    <v-container fluid>
                        <v-layout>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By Contact List Name"
                                              v-model="filter.name"></v-text-field>
                            </v-flex>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By Contact Name"
                                              v-model="filter.contactName"></v-text-field>
                            </v-flex>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By Contact Phone"
                                              v-model="filter.phoneNumber"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-btn outlined type="submit" color="success" @click="get()">
                            Search
                            <v-icon right dark>mdi-magnify-plus-outline</v-icon>
                        </v-btn>
                        <v-btn outlined color="warning" @click="resetFilter()">
                            Reset
                            <v-icon right dark>mdi-autorenew</v-icon>
                        </v-btn>
                        <v-btn outlined color="info" @click="createContactList()" v-if="$permissionHolder.hasPermission('ORGANIZATION.UPDATE')">
                            Create List
                            <v-icon right dark>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <v-data-table :headers="headers"
                          :items="contacts"
                          class="elevation-1"
                          :loading="loading">
                <template v-slot:item.actions="{ item }">
                    <v-btn icon v-if="$permissionHolder.hasPermission('ORGANIZATION.UPDATE')" v-on:click="editContactList(item.id)">
                        <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.contacts="{item}">
                    <span v-if="item.contacts && item.contacts.length > 3">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                 <span v-on="on">({{item.contacts.length}})</span>
                            </template>
                            <span v-html="getContacts(item)"></span>
                        </v-tooltip>
                    </span>
                    <span v-if="item.contacts && item.contacts.length <= 3">
                        <span v-html="getContacts(item)"></span>
                    </span>
                </template>
            </v-data-table>
            <v-dialog :eager="true" v-model="addContactListDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <CreateOrganizationContactList
                        ref="addContactListDialog"
                        @saved="contactListAdded"
                        @cancelled="contactListCancelled"></CreateOrganizationContactList>
            </v-dialog>

            <v-dialog :eager="true" v-model="editContactListDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <EditOrganizationContactList
                        ref="editContactListDialog"
                        @saved="contactListAdded"
                        @cancelled="contactListCancelled"></EditOrganizationContactList>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
    import api from '@/api';
    import CreateOrganizationContactList from "@/components/organization/contacts/CreateOrganizationContactList";
    import EditOrganizationContactList from "@/components/organization/contacts/EditOrganizationContactList";
    export default {
        name: "OrganizationContactLists",
        components: {EditOrganizationContactList, CreateOrganizationContactList},
        inject: ['getProvidedOrganization'],
        data() {
            return {
                organizationId : null,
                contacts : [],
                filter : {
                    name:'',
                    contactName:'',
                    phoneNumber: ''
                },
                headers : [
                    {text:'Name',value:'name'},
                    {text:'Contacts',value:'contacts'},
                    {text:'Actions',value:'actions'},
                ],
                addContactListDialog : false,
                editContactListDialog : false,
                loading : false
            }
        },
        mounted() {
            this.organizationId = this.getProvidedOrganization().id;
            this.get();
        },
        created() {

        },
        methods : {
            getContacts(item) {
                return item.contacts.join("<br/>");
            },
            resetFilter() {
                this.filter = {};
                this.get();
            },
            contactListAdded() {
                this.addContactListDialog = false;
                this.editContactListDialog = false;
                this.get();
            },
            contactListCancelled() {
                this.editContactListDialog = false;
                this.addContactListDialog = false;
            },
            createContactList() {
                this.addContactListDialog = true;
                this.$refs.addContactListDialog.open(this.organizationId);
            },
            editContactList(id) {
                this.editContactListDialog = true;
                this.$refs.editContactListDialog.open(id,this.organizationId);
            },
            get() {
                this.loading = true;
                api.contactList.search({
                    organizationId : this.organizationId,
                    name : this.filter.name,
                    contactName : this.filter.contactName,
                    phoneNumber : this.filter.phoneNumber
                }).then((data) => {
                    this.contacts = data.list;
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>
